module.exports = __webpack_public_path__ + "static/media/rise-affiliat-bg-image.e195cb01.png";